// BOM removed
import React from 'react';
import { Helmet } from "react-helmet-async";

import HomeHero from './HomeHero/HomeHero';
import HomeAbout from './HomeAbout/HomeAbout';
import HomeCourses from './HomeCourses/HomeCourses';
import HomeStudentLife from './HomeStudentLife/HomeStudentLife';
import HomeMessage from './HomeMessage/HomeMessage';

function Home() {
  return (
    <>
      <Helmet>
        <title>SK College | Best Arts & Science College</title>

        <meta
          name="description"
          content="Welcome to SK College. We provide quality Arts with experienced faculty, modern infrastructure, and excellent student support."
        />

        <meta
          name="keywords"
          content="SK College, Arts College, Degree College, Admissions, Courses"
        />

        <meta property="og:title" content="SK College Official Website" />
        <meta
          property="og:description"
          content="Join SK College for quality higher education and a vibrant campus life."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://skcollegemanaklao.com/" />
      </Helmet>

      <div className="home">
        <HomeHero />
        <HomeAbout />
        <HomeCourses />
        <HomeStudentLife />
        <HomeMessage />
      </div>
    </>
  );
}

export default Home;
